import { HoruzError } from '../../../../errors/error.js';
import { HoruzProtocolChulakCloseCode } from '../../codes.js';

/**
 * Error
 * @public
 */
export class HoruzProtocolChulakErrorProtocolAuthenticationTimeout extends HoruzError {
  constructor(reason?: string) {
    super(
      HoruzProtocolChulakCloseCode.PROTOCOL_AUTHENTICATION_TIMEOUT_ERROR,
      reason,
    );
  }
  /**
   * Constructs error
   * @param reason Reason
   * @returns Error
   */
  static Create(reason?: string) {
    return new this(reason);
  }
}
